import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ElementiStrutturaliL1SectionWrapper,
  InspectionInfoForm,
} from 'components';
import { CDAOptions, tipologiaPulvinoOptions } from 'constants/selectOptions';
import useTabellaRiepilogativa from 'hooks/inspections/useTabellaRiepilogativa';
import { INFO } from 'pages/Inspections/config/info';
import { calculateDifettositaComplessiva } from 'pages/Inspections/CreateInspection/utils/extractDefectivenessInfo';
import PulviniForm from './PulviniForm';
const PulviniSection = ({ selectedIdx }) => {
  const { recalculateTable } = useTabellaRiepilogativa();
  const { watch, setValue, getValues } = useFormContext();

  const spallePileCollegamentiTablePulviniTableWatch = watch(
    `spallePileCollegamentiTable[${selectedIdx}].pulviniTable`
  );

  const spallePileCollegamentiTable = watch(`spallePileCollegamentiTable`);
  //console.log(spallePileCollegamentiTable, 'spallePileCollegamentiTable');

  const spallePileToCopy = spallePileCollegamentiTable?.map(
    el => el.pulviniTable
  );

  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();
  const [openSchedaDifetti, setOpenSchedaDifetti] = useState(false);
  const [schedaDifettiIndex, setSchedaDifettiIndex] = useState();

  const editRowsPulvini = item => {
    setValue('pulviniTableValue', [item]);
    setValue('tipologiaPulvinoTableValue', item.tipologiaPulvino);
  };

  const handleSelectAllClickPulvini = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `spallePileCollegamentiTable[${selectedIdx}].pulviniTable`
      );
      setSelected(selectedValue);
      setValue('pulviniTableValue', selectedValue);
    } else {
      setSelected([]);
      setValue('pulviniTableValue', []);
    }
  };

  useEffect(() => {
    setValue(
      'l1t2a3_tecnicoRilevatorePulvini',
      getValues(
        `spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${schedaDifettiIndex}].tecnicoRilevatore`
      ) ||
        getValues('rilevatoreRischioStrutturale') ||
        ''
    );
    setValue(
      'l1t2a3_dataIspezionePulvini',
      getValues(
        `spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${schedaDifettiIndex}].dataIspezione`
      ) ||
        getValues('dataIspezioneRischioStrutturale') ||
        null
    );
    setValue(
      'l1t2a3_elementoCriticoStrutturaPulvini',
      getValues(
        `spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${schedaDifettiIndex}].elementoCriticoStruttura`
      ) || ''
    );
    setValue(
      'l1t2a3_elementoCriticoSismicaPulvini',
      getValues(
        `spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${schedaDifettiIndex}].elementoCriticoSismica`
      ) || ''
    );
    setValue(
      'l1t2a3_condizioneCriticaStrutturaPulvini',
      getValues(
        `spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${schedaDifettiIndex}].condizioneCriticaStruttura`
      ) || ''
    );
    setValue(
      'l1t2a3_condizioneCriticaSismicaPulvini',
      getValues(
        `spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${schedaDifettiIndex}].condizioneCriticaSismica`
      ) || ''
    );
    setValue(
      'l1t2a3_noteGeneraliPulvini',
      getValues(
        `spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${schedaDifettiIndex}].noteGenerali`
      ) || ''
    );
  }, [schedaDifettiIndex]);

  const handleSaveInspection = () => {
    const tecnicoRilevatore = getValues('l1t2a3_tecnicoRilevatorePulvini');
    const dataIspezione = getValues('l1t2a3_dataIspezionePulvini');
    const elementoCriticoStruttura = getValues(
      'l1t2a3_elementoCriticoStrutturaPulvini'
    );
    const elementoCriticoSismica = getValues(
      'l1t2a3_elementoCriticoSismicaPulvini'
    );
    const condizioneCriticaStruttura = getValues(
      'l1t2a3_condizioneCriticaStrutturaPulvini'
    );
    const condizioneCriticaSismica = getValues(
      'l1t2a3_condizioneCriticaSismicaPulvini'
    );
    const noteGenerali = getValues('l1t2a3_noteGeneraliPulvini');
    setValue(
      `spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${schedaDifettiIndex}].tecnicoRilevatore`,
      tecnicoRilevatore
    );
    setValue(
      `spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${schedaDifettiIndex}].dataIspezione`,
      dataIspezione
    );
    setValue(
      `spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${schedaDifettiIndex}].elementoCriticoStruttura`,
      elementoCriticoStruttura
    );
    setValue(
      `spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${schedaDifettiIndex}].elementoCriticoSismica`,
      elementoCriticoSismica
    );
    setValue(
      `spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${schedaDifettiIndex}].condizioneCriticaStruttura`,
      condizioneCriticaStruttura
    );
    setValue(
      `spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${schedaDifettiIndex}].condizioneCriticaSismica`,
      condizioneCriticaSismica
    );
    setValue(
      `spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${schedaDifettiIndex}].noteGenerali`,
      noteGenerali
    );
    setValue('l1t2a5_trigger', Math.random() * 1000);
    setTimeout(() => {
      recalculateTable();
    }, 0);

    // Gestione calcolo difettosità complessiva nella tabella riepilogativa
    const tableWatch = getValues('riepilogoStrutturaTable');
    const difettositaStrutturaleEffettiva = watch(
      'arbitraryStructuralFoundationalDefectiveness'
    );
    const difettositaSismicaEffettiva = watch('arbitrarySeismicDefectiveness');
    const tabellaRiepilogativa = tableWatch.filter(
      row => row.codice !== 'Difettosità complessiva'
    );
    const { difettositaStrutturale, difettositaSismica } =
      calculateDifettositaComplessiva(tabellaRiepilogativa);
    const updatedTable = tableWatch.map(row => {
      if (row.codice === 'Difettosità complessiva') {
        return {
          ...row,
          difettositaStrutturale,
          difettositaSismica,
        };
      }
      return row;
    });
    setValue('riepilogoStrutturaTable', updatedTable);
    !difettositaStrutturaleEffettiva &&
      setValue(
        'arbitraryStructuralFoundationalDefectiveness',
        difettositaStrutturale
      );
    !difettositaSismicaEffettiva &&
      setValue('arbitrarySeismicDefectiveness', difettositaSismica);
  };

  const handleResetInspection = () => {
    setValue(`l1t2a3_tecnicoRilevatorePulvini`, '');
    setValue(`l1t2a3_dataIspezionePulvini`, null);
    setValue(`l1t2a3_elementoCriticoStrutturaPulvini`, '');
    setValue(`l1t2a3_elementoCriticoSismicaPulvini`, '');
    setValue(`l1t2a3_condizioneCriticaStrutturaPulvini`, '');
    setValue(`l1t2a3_condizioneCriticaSismicaPulvini`, '');
    setValue(`l1t2a3_noteGeneraliPulvini`, '');
  };

  const dataPulviniConfig = {
    columns: {
      codice: { label: 'Cod.' },
      tipologiaPulvino: { label: 'Tipologia', format: tipologiaPulvinoOptions },
      completamentoSchedaDifetti: { label: 'Completamento Scheda' },
      indiceCondizione: { label: 'Indice di condizione' },
      CDAstrutturale: { label: 'Difettosità Str.', format: CDAOptions },
      CDAsismica: { label: 'Difettosità Sis.', format: CDAOptions },
      nrtotali: { label: 'NR' },
      g5totali: { label: 'G=5' },
      pstotali: { label: 'PS' },
    },
  };

  const copyTableConfig = {
    columns: {
      codice: { label: 'Codice' },
      tipologiaPulvino: {
        label: 'Tipologia',
        format: tipologiaPulvinoOptions,
      },
    },
  };

  const spallePileCollegamentoSelezione = watch(
    'spallePileCollegamentoSelezione'
  );

  useEffect(() => {
    if (spallePileCollegamentoSelezione) {
      setSchedaDifettiIndex(undefined);
      setOpenSchedaDifetti(false);
    }
  }, [spallePileCollegamentoSelezione]);

  useEffect(() => {
    if (schedaDifettiIndex !== undefined) {
      setOpenSchedaDifetti(true);
    }
  }, [schedaDifettiIndex]);

  return (
    <>
      <ElementiStrutturaliL1SectionWrapper
        selectedIdx={selectedIdx}
        elementTitle={'pulvini'}
        infoDrawer={true}
        drawerTitle={INFO.collegamentiPulvini.drawerTitle}
        drawerText={INFO.collegamentiPulvini.drawerText}
        singleElementTitle={'pulvino'}
        tableWatch={spallePileCollegamentiTablePulviniTableWatch}
        tableWatchName={`spallePileCollegamentiTable[${selectedIdx}].pulviniTable`}
        elementForm={
          <PulviniForm
            pulviniFields={spallePileCollegamentiTablePulviniTableWatch || []}
            selected={selected}
            setSelected={setSelected}
            pulviniTable={`spallePileCollegamentiTable[${selectedIdx}].pulviniTable`}
            selectedIdx={selectedIdx}
          />
        }
        inspectionInfoForm={
          <InspectionInfoForm
            onSubmit={handleSaveInspection}
            onReset={handleResetInspection}
            tecnicoRilevatoreName={'l1t2a3_tecnicoRilevatorePulvini'}
            dateName={'l1t2a3_dataIspezionePulvini'}
            elementoCriticoStrutturaName={
              'l1t2a3_elementoCriticoStrutturaPulvini'
            }
            elementoCriticoSismicaName={'l1t2a3_elementoCriticoSismicaPulvini'}
            condizioneCriticaStrutturaName={
              'l1t2a3_condizioneCriticaStrutturaPulvini'
            }
            condizioneCriticaSismicaName={
              'l1t2a3_condizioneCriticaSismicaPulvini'
            }
            noteGeneraliName={'l1t2a3_noteGeneraliPulvini'}
          />
        }
        tableConfig={dataPulviniConfig}
        editRows={editRowsPulvini}
        selected={selected}
        setSelected={setSelected}
        handleSelectAllClick={handleSelectAllClickPulvini}
        drawerMediaIndex={drawerMediaIndex}
        setDrawerMediaIndex={setDrawerMediaIndex}
        schedaDifettiIndex={schedaDifettiIndex}
        setSchedaDifettiIndex={setSchedaDifettiIndex}
        open={open}
        setOpen={setOpen}
        openSchedaDifetti={openSchedaDifetti}
        setOpenSchedaDifetti={setOpenSchedaDifetti}
        copyTableConfig={copyTableConfig}
        copyType={'tipologiaPulvino'}
        tableForCopy={spallePileToCopy}
      />
    </>
  );
};
PulviniSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default PulviniSection;
